import type { PropsWithChildren } from 'react';
import type { DropDownListProps } from '@progress/kendo-react-dropdowns';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DropDownListPropsContext } from '@progress/kendo-react-dropdowns';

import type { ContextPops } from './_base.type';

const DropDownListPropsContextProvider = function ({ children }: PropsWithChildren) {
  const { t } = useTranslation();

  const listNoDataRender = useCallback<NonNullable<DropDownListProps['listNoDataRender']>>(
    () => (
      <div className="k-nodata">
        <div>{t(`noDataFound`)}</div>
      </div>
    ),
    [t],
  );

  const calendarProps = useCallback<ContextPops<DropDownListProps>>(
    (props) => ({
      ...props,

      listNoDataRender,
    }),
    [listNoDataRender],
  );

  return <DropDownListPropsContext.Provider value={calendarProps}>{children}</DropDownListPropsContext.Provider>;
};

export default DropDownListPropsContextProvider;
